export const page = state => state.page;
export const history = state => state.history;



